module.exports = __webpack_public_path__ + "img/loading.16932e3e.gif";